import { Button, DialogActions, DialogContent, DialogContentText } from "@mui/material";

type NoInstrumentsConfirmDialogProps = {
    onCancel: () => void;
    onConfirm: () => void;
};

export const NoInstrumentsConfirmDialog = ({ onCancel, onConfirm }: NoInstrumentsConfirmDialogProps) => {
    return (
        <>
            <DialogContent>
                <DialogContentText>
					Nenhum instrumento foi selecionado nesta avaliação (pode adicionar, no modo editar, em Provas de Avaliação Psicológica - Instrumentos).
					Deseja continuar sem instrumentos selecionados?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onCancel}>
                    Cancelar
                </Button>
                <Button onClick={onConfirm}>Continuar</Button>
            </DialogActions>
        </>
    );
};
